import React, { useEffect } from 'react';
import { actions } from 'redux/actions';
import Shared from 'screens/shared';
import { ROUTE, MONTH } from 'constant';
import { _t, getKey } from 'utils';
import { useSelector } from 'react-redux';
import { ACTIONS_TYPES } from 'redux/helper';

export const InvoiceList = ({ history }) => {
  const { [ACTIONS_TYPES.BILLING.GET_INVOICES]: invoices = {} } = useSelector((e) => e);
  let { invoices: invoiceItems = [] } = invoices;
  invoiceItems = invoiceItems.sort((a, b) => (a.date < b.date ? 1 : -1)).slice(0, 6);

  useEffect(() => {
    const contractId = getKey('selectedContractId');
    actions.billing.getInvoices({ contractId });
  }, []);

  const getYear = (date) => date.split('-').map((e) => parseInt(e, 10))[0] || '';
  const getMonth = (date) => _t(MONTH[date.split('-').map((e) => parseInt(e, 10))[1]]) || '';
  const [currentYear, currentMonth] = [new Date().getFullYear(), new Date().getMonth() + 1];

  return (
    <Shared.widgets.Page route={ROUTE.DASHBOARD.INVOICES} isStrap={false}>
      <Shared.widgets.Section
        sectionTitle="Current Invoice"
        items={[{ currentYear, currentMonth }]}
        itemIcon="file-invoice-dollar"
        setItemTitle={(e) => <span>{`${_t(MONTH[e?.currentMonth])}, ${e?.currentYear}`}</span>}
        itemOnClick={() => history.push(ROUTE.DASHBOARD.INVOICE_CURRENT.path)}
        tableColumns={['', 'Name', '']}
      />
      <Shared.widgets.Section
        sectionTitle="Previous Invoices"
        items={invoiceItems}
        className="-m-t-24"
        itemIcon="file-invoice-dollar"
        setItemTitle={(e) => <span>{`${getMonth(e?.date)}, ${getYear(e?.date)}`}</span>}
        itemOnClick={(e) => history.push(ROUTE.DASHBOARD.INVOICE.path.replace(':id', e?.id))}
        tableColumns={['', 'Name', '']}
      />
    </Shared.widgets.Page>
  );
};
